// The node components React Flow renders, keyed by the `type` used in a workflow graph.
//
// Shared by the graph editor and the admin node preview so the preview can never drift from
// what the editor actually draws.
import { Node } from "./Node";
import {
  InputDocumentNode,
  ChromaInputNode,
  RouterNode,
  DataSetNode,
  DatabaseNode,
  LLMNode,
  TextSplittingNode,
  GenerateQuestionsNode,
  InputNode,
  TextOutputNode,
  PythonNode,
  ConditionalNode,
  WorkflowNode,
  WebFetchNode,
  SQLQueryNode,
} from "./index";

export const nodeTypes = {
  defaultNode: Node,
  inputDocumentNode: InputDocumentNode,
  chromaInputNode: ChromaInputNode,
  routerNode: RouterNode,
  dataSetNode: DataSetNode,
  databaseNode: DatabaseNode,
  llmNode: LLMNode,
  textSplittingNode: TextSplittingNode,
  generateQuestionsNode: GenerateQuestionsNode,
  inputNode: InputNode,
  textOutputNode: TextOutputNode,
  pythonNode: PythonNode,
  conditionalNode: ConditionalNode,
  workflowNode: WorkflowNode,
  webFetchNode: WebFetchNode,
  sqlQueryNode: SQLQueryNode,
};

export default nodeTypes;
